import ABtn from '../../vue/Components/Navigation/ABtn.vue'
import AppHeader from '../../vue/Components/Layout/AppHeader.vue'

export default {
  components: {
    ABtn,
    AppHeader,
  },
}
